import React, {createContext, useEffect, useState} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';
import {v4 as uuid} from 'uuid';

// Import des pages
import Home from './pages/Home';
import StandardDon from './pages/StandardDon';
import SelectDep from './pages/SelectDep';
import Billetterie from './pages/Billetterie';
import Inscription from './pages/Inscription';
import Projets from './pages/Projets';
import SoutienProjet from './pages/SoutienProjet';
import Panier from './pages/Panier';
import StatusPaiement from './pages/StatusPaiement';
import Login from './pages/Login';
import Register from './pages/Register';
import Apropos from './pages/Apropos';
import ComplementaryInfo from './pages/ComplementaryInfo';
import DonInstitutions from './pages/DonInstitutions';
import DonCatastrophes from './pages/DonCatastrophesNat';

// Import des polices Roboto
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

export const Context = createContext()

function App() {
  const [region, setRegion] = useState(localStorage.getItem('region') || null);
  const [regions, setRegions] = useState([]);
  const [userId, setUserId] = useState(localStorage.getItem('user') || localStorage.getItem('anonUserId') || null);
  const [isConnected, setIsConnected] = useState(!!localStorage.getItem('token'));

  const deconnect = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    localStorage.removeItem('user');
    setUserId(localStorage.getItem('anonUserId') || null);
    setIsConnected(false);
  }

  useEffect(() => { 
    // Fetch regions from the API
    if(regions.length === 0) {
      fetch(`${process.env.REACT_APP_THYBA_API_URL}/regions/by?`+ new URLSearchParams({ availableOnEsdras: true }).toString(), { method: 'GET' })
      .then(response => response.json())
      .then(data => setRegions(data))
      .catch(error => console.error('Error fetching regions:', error));
    }
    
    if (!(!!userId)) {
      let userId = localStorage.getItem('anonUserId');
      if (!userId) {
        userId = uuid();
        localStorage.setItem('anonUserId', userId);
      }
      setUserId(userId);
    }
  }, []);

  return (
    <Context.Provider value={{region, setRegion, regions, userId, setUserId, isConnected, setIsConnected, deconnect}}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {region===null? <Route path="*" element={<SelectDep />} />
          :<><Route path="/" element={<Home />} />
          <Route path='/connexion' element={<Login />} />
          <Route path='/register' element={<Register />} />
          <Route path='/info_complementaire' element={<ComplementaryInfo />} />
          <Route path="/donate" element={<StandardDon />} />
          <Route path="/don_institutions" element={<DonInstitutions />} />
          <Route path="/don_catastrophes" element={<DonCatastrophes />} />
          <Route path="/billeterie" element={<Billetterie />} />
          <Route path="/billetterie/:id" element={<Inscription />} />
          <Route path='/projets' element={<Projets />} />
          <Route path='/projets/:id' element={<SoutienProjet />} />
          <Route path="/panier" element={<Panier />} />
          <Route path="/paiement/status" element={<StatusPaiement />} />
          <Route path="/about_us" element={<Apropos />} />
          <Route path="*" element={<Home />} /></>}
        </Routes>
      </Router>
    </ThemeProvider>
    </Context.Provider>
  );
}
export default App;